var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_201_4999",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 27,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 27,
    height: 27,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_201_4999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.39828 15.3899L12.2299 19.2215C12.4029 19.3946 12.4884 19.5971 12.4861 19.8291C12.4839 20.0611 12.3985 20.2674 12.2299 20.4479C12.0493 20.6285 11.842 20.7217 11.6077 20.7277C11.3735 20.7337 11.1661 20.6464 10.9855 20.4658L5.77308 15.2534C5.56271 15.043 5.45752 14.7976 5.45752 14.5171C5.45752 14.2366 5.56271 13.9912 5.77308 13.7808L10.9855 8.56832C11.1586 8.39525 11.3641 8.30982 11.6021 8.31205C11.8401 8.3143 12.0493 8.40569 12.2299 8.58621C12.3985 8.76676 12.4857 8.97117 12.4917 9.19945C12.4977 9.42772 12.4104 9.63213 12.2299 9.81265L8.39828 13.6443H22.0908C22.3385 13.6443 22.5459 13.7278 22.713 13.8949C22.8801 14.062 22.9636 14.2694 22.9636 14.5171C22.9636 14.7648 22.8801 14.9721 22.713 15.1392C22.5459 15.3063 22.3385 15.3899 22.0908 15.3899H8.39828Z",
    fill: "#3C3C3C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftAlt);
export default __webpack_public_path__ + "static/media/arrow_left_alt.0384bb518d4d7416f099e55dc4398f23.svg";
export { ForwardRef as ReactComponent };